import React from 'react'
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps'
import mapMarker from '../../assets/mapMarker.svg'
import openInNewTab from '../../utils/openInNewTab'

const mapsApiUrl = 'https://www.google.com/maps/search/?api=1&query='
const iceBlue = [
  {
    stylers: [
      {
        hue: '#2c3e50'
      },
      {
        saturation: 250
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        lightness: 50
      },
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }
]

const openMap = (urlParams) => () => {
  openInNewTab(`${mapsApiUrl}${urlParams.join('+')}`)
}

export const LocationMap = ({ geoloc, isMarkerShown, urlParams }) => (
  <GoogleMap
    defaultZoom={14}
    center={geoloc}
    defaultOptions={{ styles: iceBlue }}
  >
    { isMarkerShown && <Marker position={geoloc} options={{ icon: mapMarker }} onClick={openMap(urlParams)} /> }
  </GoogleMap>
)

const WrappedGoogleMap = withGoogleMap(LocationMap)

// Create a new component that handles script loading conditionally
const SafeGoogleMap = props => {
  // If Google Maps is already loaded, render map directly
  // If user comes from search page then it will be loaded
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    return (
      <WrappedGoogleMap {...props} />
    )
  }

  // If Google Maps is not loaded, pass it to withScriptjs
  // If user loads the page url directly from browser google maps won't be loaded yet
  const MapWithScript = withScriptjs(WrappedGoogleMap)
  return <MapWithScript {...props} />
}

export default SafeGoogleMap
